import axios from 'axios'
import MarkdownIt from "markdown-it";
import imgPDF from '@/assets/images/pdf.png';
//Clase para manejar funciones basicas
class helperFunctions {
    //Funcion para enviar por axios
    sendAxios(datasend, url) {
        return new Promise((resolve, reject) => {
            axios.post(url, datasend, {
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(function (response) {
                    resolve(response.data);
                })
                .catch(function (error) {
                    console.log(error);
                    reject(error);
                });
        });
    }
    //Funcion para enviar el mensaje a codeneigther por axios
    postServerFuncion(jsonEnvio, url) {
        return this.sendAxios(jsonEnvio, url + 'bot/web')
    }

    //Funcion para mandar el medio a codeneither
    async sendMessageCodeneitherMedio(medio_send, url, user) {
        //Si traemos un archivo lo enviamos
        var formData = new FormData();
        formData.append("number", user.id);
        formData.append("search", 'widget');
        formData.append("tel", user.session);
        let medio = medio_send.files;
        formData.append("file", medio[0]);
        formData.append("text", 'archivos');
        const Http = new XMLHttpRequest();
        Http.open("POST", url + '/bot/multimedia', true);
        Http.send(formData);
        if (Http.readyState === XMLHttpRequest.DONE) {
            return Http;
        }
        let res;
        //Enviampos promesa y retornamos la respuesta o el error
        const p = new Promise((r) => res = r);
        Http.onreadystatechange = () => {
            let response = Http.responseText;
            if (response != '') {
                let response = JSON.parse(Http.responseText);
                if (response.validate) {
                    //Enviamos el mensaje y esperamos una respuesta del bot
                    let mensajeSend = {
                        message: {
                            message: {
                                attachments: [
                                    {
                                        type: response.type,
                                        payload: response.url
                                    }
                                ]
                            },
                            type: response.type,
                            custom_multimedia: {
                                url: response.url,
                                mime_type: response.mime
                            }
                        },
                        iduser: user.id,
                        session: user.session,
                        channel: user.channel
                    };
                    res(mensajeSend);
                } else {
                    alert('error');
                }
            }
        }
        return p;
    }
    //Verificar si es html
    isHtml(input) {
        const htmlPattern = /<([a-z]+)([^<]+)*(?:>(.*)<\/\1>|\s+\/>)/i;
        return htmlPattern.test(input);
    }
    //Verificar si es markdown
    isMarkdown(input) {
        const markdownPatterns = [
            /\*\*[^*\n]+\*\*/,          // Negrita **texto** (sin esto cae en tostrongtext y deja asteriscos sueltos)
            /(^|\s)#{1,6}\s/,           // Encabezados (#, ##, ###, etc.)
            /(^|\n)\s*[-*+]\s+[^-\s]/,  // Listas no ordenadas ajustadas (deben tener texto luego del marcador)
            /!\[.*\]\(.*\)/,            // Imágenes ![alt](url)
            /\[.*\]\(.*\)/,             // Enlaces [text](url)
            /^> /,                      // Citas
            /```[\s\S]*```/,            // Bloques de código
            /`[^`]+`/,                  // Código en línea
            /^[-*_]{3,}$/,              // Líneas horizontales
        ];
        const containsMarkdownPatterns = markdownPatterns.some(pattern => pattern.test(input));
        return containsMarkdownPatterns;
    }
    //Build slider
    buildSlider(elements, widget, message_parent = false) {
        let interactive =
            `<div class="swiper swiper-container">
            <div class="swiper-wrapper">`;
        //Recorremos el array de los elementos
        for (let elemento of elements) {
            interactive += `
                <div class="swiper-slide">
                    <div class="widget_card">
                        ${(elemento?.image_url && elemento.image_url != '') ? `<img src="${elemento.image_url}" alt="Card">` : ''}
                        ${(elemento?.title && elemento.title != '') ? `<p class="title_buttones">${elemento.title}</p>` : ''}
                        ${(elemento?.subtitle && elemento.subtitle != '') ? `<p class="subtitle_buttones">${elemento.subtitle}</p>` : ''}`;
            //Verificamos si existe los botones de las tarjetas
            if (elemento?.buttons?.length > 0) {
                elemento.buttons.forEach(boton => {
                    if (boton?.type && boton.type !== '') {
                        let payload;
                        if (boton?.payload && boton.payload !== '') {
                            payload = boton.payload;
                        } else if (boton?.url && boton.url !== '') {
                            payload = boton.url;
                        }
                        interactive += `<p class="card_boton widget_card_boton" style="border-radius: 0 0 8px 8px;background-color: ${widget.color_primary};color:${widget.color_message_text}" type="${boton.type}" payload="${payload}" idmessage="${message_parent?.channel_message_id}">${boton.title}</p>`;
                    }
                });
            }
            interactive += `    
                    </div>
                </div>`;
        }
        interactive +=
            `   </div>
            <div class="swiper-button-prev">
                <svg style="color:${widget.color}" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                    <path d="M5 12l14 0"></path>
                    <path d="M5 12l6 6"></path>
                    <path d="M5 12l6 -6"></path>
                </svg>
                </div>
            <div class="swiper-button-next">
                <svg style="color:${widget.color}" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                    <path d="M5 12l14 0"></path>
                    <path d="M13 18l6 -6"></path>
                    <path d="M13 6l6 6"></path>
                </svg>
            </div>
        </div>`;
        return interactive;
    }
    //Funcion para genera los mensajes del bot
    buildMensajeWeb(message, widget, message_parent = false) {
        try {
            //Retornamos si es un mensaje del sistema
            if (message_parent && message_parent?.sender_type == 'system') {
                return '';
            }
            let htmlprint = '';
            let interactive = '';
            let message_print = message;
            let is_markdown = false;
            //================================================================================================
            //Verificamos si viene textos
            if (message_print?.text) {
                const rendered = this.renderRichText(message_print.text);
                is_markdown = rendered.is_markdown;
                htmlprint = `<div class="widget_message_content ${is_markdown ? 'widget_message_content_markdown' : ''}">${rendered.html}</div>`;
            }
            //Verificamos si vienen tarjetas
            if (message_print?.attachment?.payload?.elements || message_print?.cards) {
                let elements;
                let verifyCard = false;
                htmlprint = '';
                //Verificamos si elements es un array o un objeto
                if (message_print?.attachment?.payload?.elements) {
                    if (!Array.isArray(message_print.attachment.payload.elements)) {
                        elements = [message_print.attachment.payload.elements];
                    } else {
                        elements = message_print.attachment.payload.elements;
                    }
                }
                if (message_print?.cards) {
                    elements = message_print.cards;
                }
                //Verificamos si tiene imagen para lanzarlo como tarjetas
                for (let elemento of elements) {
                    if (elemento?.image_url || elemento?.title) {
                        verifyCard = true;
                    }
                }
                //si es tarjeta
                if (verifyCard) {
                    interactive = this.buildSlider(elements, widget, message_parent);
                } else {
                    interactive += `
                    <div class="widget_message_botones">`;
                    for (let boton of elements) {
                        boton.buttons.forEach(element => {
                            let text_boton = element.payload ? element.payload : element.title;
                            let payload = element.payload;
                            if (element.type == 'web_url') {
                                payload = element.url;
                            }
                            interactive += `<span onmouseover="this.style.backgroundColor='${widget.color_primary}';this.style.color='${widget.color_message_text}'" onmouseout="this.style.backgroundColor='white';this.style.color='${widget.color_primary}'" style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;border-color: ${widget.color_primary}; color: ${widget.color_primary}" class="widget_message_boton" type="${element.type}" payload="${payload}" idmessage="${message_parent?.channel_message_id}">${text_boton}</span>`;
                        });
                    }
                    interactive += `
                    </div>`;
                }
            }
            if (message_print?.attachment?.payload?.buttons?.length > 0) {
                interactive += `
                <div class="widget_message_botones widget_message_botones_quickreply">`;
                for (let boton of message_print.attachment.payload.buttons) {
                    let payload = boton.payload;
                    if (boton.type == "web_url") {
                        payload = boton.url;
                    }
                    interactive += `<span style="color: ${widget.color}" class="widget_message_boton" type="${boton.type}" payload="${payload}" idmessage="${message_parent?.channel_message_id}">${boton.title}</span>`;
                }
                interactive += `
                </div>`;
            }
            if (message_print?.buttons?.length > 0) {
                let buttons = message_print?.buttons || [];
                interactive += `
                <div class="widget_message_botones">`;
                for (let boton of buttons) {
                    let title = boton.label;
                    let type = boton.type;
                    let payload = boton.value;
                    if (type == "url") {
                        type = "web_url";
                        payload = boton.value;
                    }
                    interactive += `<span onmouseover="this.style.backgroundColor='${widget.color_primary}';this.style.color='${widget.color_message_text}'" onmouseout="this.style.backgroundColor='white';this.style.color='${widget.color_primary}'" style="border-color: ${widget.color_primary}; color: ${widget.color_primary}" class="widget_message_boton" type="${type}" payload="${payload}" idmessage="${message_parent?.channel_message_id}">${title}</span>`;
                }
                interactive += `
                </div>`;
            }
            //Verificamos si viene buttones (solo si hay quick_replies con al menos un elemento)
            if (Array.isArray(message_print?.quick_replies) && message_print.quick_replies.length > 0) {
                htmlprint = '';
                if (message_print?.text) {
                    interactive += `
                <div class="widget_message widget_message_bot">
                    <p>${message_print.text}</p>
                </div>`;
                }
                interactive += `
                <div class="widget_message_botones">`;
                for (let boton of message_print.quick_replies) {
                    if (boton.content_type == "text" || boton.content_type == "web_url") {
                        // web_url => el handler de click hace window.open(payload)
                        const bpayload = boton.content_type == "web_url" ? (boton.url ?? boton.payload) : boton.payload;
                        interactive += `<span onmouseover="this.style.backgroundColor='${widget.color_primary}';this.style.color='${widget.color_message_text}'" onmouseout="this.style.backgroundColor='white';this.style.color='${widget.color_primary}'" style="border-color: ${widget.color_primary}; color: ${widget.color_primary}" class="widget_message_boton" type="${boton.content_type}" payload="${bpayload}" idmessage="${message_parent?.channel_message_id}">${boton.title}</span>`;
                    }
                }
                interactive += `
                </div>`;
            }
            //Verificamos si viene multliple
            if (message_print?.attachment?.type == 'audio') {
                htmlprint = `<audio controls><source src="${message_print.attachment.payload.url}" type="audio/mpeg"></audio>`;
            }
            if (message_print?.attachment?.type == 'image') {
                htmlprint = `<img src="${message_print.attachment.payload.url}" alt="">`;
            }
            if (message_print?.attachment?.type == 'video') {
                htmlprint = `<video controls playsinline><source src="${message_print.attachment.payload.url}" type="video/mp4"></video>`;
            }
            if (message_print?.attachment?.type == 'file') {
                htmlprint = this.buildDocumentCard(message_print.attachment.payload.url);
            }
            //Verificamos los medios de attachments
            if (message_print?.attachments?.length > 0) {
                message_print.attachments.forEach(element => {
                    if (element?.type == 'image') {
                        htmlprint = `<img src="${element.url}"/>`;
                    } else if (element?.type == 'audio') {
                        htmlprint = `<audio controls=""><source src="${element.url}" type="audio/mp4"></audio>`;
                    } else if (element?.type == 'file') {
                        htmlprint = this.buildDocumentCard(element.url);
                    } else if (element?.type == 'video') {
                        htmlprint = `<video controls="" playsinline><source src="${element.url}" type="video/mp4"></video>`;
                    } else if (element?.type == 'document') {
                        htmlprint = this.buildDocumentCard(element.url);
                    }
                });
            }
            //Verificamos si es un array
            if (Array.isArray(message_print)) {
                interactive = `
                <div class="widget_message_botones">`;
                //Recorremos el array
                for (let boton of message_print) {
                    //Imprimimos los botones
                    if (boton.content_type == "text") {
                        interactive += `<span onmouseover="this.style.backgroundColor='${widget.color_primary}';this.style.color='${widget.color_message_text}'" onmouseout="this.style.backgroundColor='white';this.style.color='${widget.color_primary}'" style="border-color: ${widget.color_primary}; color: ${widget.color_primary}" class="widget_message_boton" type="${boton.content_type}" payload="${boton.payload}" idmessage="${message_parent?.channel_message_id}">${boton.title}</span>`;
                    }
                }
                interactive += `
                </div>`;
            }
            //Verificamos si esta vacio
            if (htmlprint != '') {
                //Verificamos si hay salto de lineas
                if (!is_markdown) {
                    htmlprint = htmlprint.replace(/\\n/g, "<br>").replace(/\r?\n/g, "<br>");
                }
                // Acuse de entrega, estilo WhatsApp. Solo en mensajes del USUARIO.
                //   1 check  = pintado en local, todavia sin fila en `messages`.
                //   2 checks = la fila ya existe en la BD.
                // El estado se deriva de `message_parent`: si viene, el mensaje se
                // esta construyendo A PARTIR de una fila real (historial o realtime),
                // luego esta persistido. Si no viene, es el eco local del envio.
                //
                // Con el turno agrupado esto es justo lo que el cliente necesita ver:
                // los N mensajes de una rafaga esperan con un check durante la ventana
                // de debounce y pasan a doble TODOS A LA VEZ cuando se entregan.
                const esUsuario = (!message_parent || message_parent?.sender_type == 'user');
                // Va FUERA de la burbuja, en su propia linea y pegado al borde
                // derecho, como en WhatsApp. `.widget_row_message` es flex con
                // flex-wrap, asi que `width:100%` lo empuja a una linea propia; el
                // margen superior negativo recupera el `margin-bottom:20px` de
                // `.widget_message_user` para que quede justo bajo la burbuja y no
                // flotando. El letter-spacing junta los dos checks.
                const ack = esUsuario
                    ? `<span class="lv-ack" data-ack="${message_parent ? '2' : '1'}" style="display:block;width:100%;text-align:right;font-size:14px;line-height:1;opacity:0.55;letter-spacing:-2px;margin-top:-16px;margin-bottom:0px;">${message_parent ? '&#10003;&#10003;' : '&#10003;'}</span>`
                    : '';
                return `
                <div class="widget_message ${esUsuario ? 'widget_message_user' : 'widget_message_bot'}"  style="${esUsuario ? 'background-color: ' + widget.color_primary + '; color: ' + widget.color_message_text + ';' : ''}">
                    ${htmlprint}
                </div>${ack}`;
            } else if (interactive != '') {
                return interactive;
            } else {
                console.log(JSON.stringify(message));
                return ``;
            }
        } catch (error) {
            console.log(error);
            throw new Error('Something gone wrong!')
        }
    }
    // Normaliza ui_components del backend y devuelve HTML renderizable por el widget
    buildUiComponentsHtml(ui_components, widget) {
        if (!Array.isArray(ui_components) || ui_components.length === 0) return '';

        let html = '';

        for (const component of ui_components) {
            if (!component || typeof component !== 'object') continue;

            // -------------------------
            // QUICK REPLIES
            // Acepta:
            // - ["a","b"]
            // - [{title,payload}]
            // - [{label,action}]
            // -------------------------
            if (Array.isArray(component.quick_replies) && component.quick_replies.length > 0) {
                const quick_replies = component.quick_replies
                    .map((r) => {
                        if (typeof r === 'string') {
                            return { title: r, payload: r, content_type: 'text' };
                        }
                        const title = r?.title ?? r?.label ?? r?.text ?? '';
                        const payload = r?.payload ?? r?.action ?? r?.value ?? r?.postback ?? title;
                        if (!title) return null;
                        return { title, payload, content_type: 'text' };
                    })
                    .filter(Boolean);

                if (quick_replies.length > 0) {
                    html += this.buildMensajeWeb({ quick_replies }, widget);
                }
            }

            // -------------------------
            // BUTTONS
            // Acepta:
            // - ["a","b"]
            // - [{title,payload,type?}]
            // - [{label,value,type?}]
            // - [{label,action,type?}]
            // Render esperado por buildMensajeWeb: {buttons:[{label,value,type}]}
            // -------------------------
            if (Array.isArray(component.buttons) && component.buttons.length > 0) {
                const buttons = component.buttons
                    .map((b) => {
                        if (typeof b === 'string') {
                            return { label: b, value: b, type: 'postback' };
                        }
                        const label = b?.label ?? b?.title ?? b?.text ?? '';
                        const value = b?.value ?? b?.payload ?? b?.action ?? b?.postback ?? label;
                        const type = b?.type ?? 'postback';
                        if (!label) return null;
                        return { label, value, type };
                    })
                    .filter(Boolean);

                if (buttons.length > 0) {
                    html += this.buildMensajeWeb({ buttons }, widget);
                }
            }

            // -------------------------
            // CARDS (si ya las soportas)
            // -------------------------
            if (Array.isArray(component.cards) && component.cards.length > 0) {
                html += this.buildMensajeWeb({ cards: component.cards }, widget);
            }
        }

        return html;
    }
    //Funcion para construir el card de documento/pdf
    buildDocumentCard(url) {
        let fileName = '';
        try {
            const parts = decodeURIComponent(url).split('/');
            fileName = parts[parts.length - 1].split(/[?#]/)[0];
        } catch (e) {
            fileName = 'Documento';
        }
        const ext = fileName.split('.').pop().toUpperCase();
        return `<div class="widget_message_document">
            <a href="${url}" target="_blank">
                <div class="widget_doc_icon">
                    <img src="${imgPDF}">
                    <span class="widget_doc_ext">${ext}</span>
                </div>
                <div class="widget_doc_info"><span class="widget_doc_name" title="${fileName}">${fileName}</span><span class="widget_doc_action">Abrir archivo</span></div>
            </a>
        </div>`;
    }
    //Funcion para convertir urls en links
    urlify(text) {
        const regex = /((https?:\/\/|www\.)[^\s]+?)([.,;¹²³)]*)(?=\s|$)/g;
        return text.replace(regex, (match, url, proto, trailing) => {
            const href = url.startsWith('http') ? url : `https://${url}`;
            let visible = url.replace(/^https?:\/\//, '');
            visible = visible.split(/[?#]/)[0];
            visible = visible.replace(/\/$/, '');
            return `<a target="_blank" href="${href}">${visible}</a>${trailing}`;
        });
    }
    // Render de un texto de mensaje a HTML. Vive aparte de `buildMensajeWeb`
    // porque el preview del streaming (App.vue) tiene que pintar EXACTAMENTE
    // igual: mientras solo hacia `replace(/\n/g,'<br>')`, el Markdown del
    // modelo se veia crudo (`**deixalleria**`) durante todo el turno, y se
    // quedaba asi para siempre si el INSERT de realtime no llegaba a reponer
    // el mensaje canonico.
    renderRichText(text) {
        if (!text) return { html: '', is_markdown: false };
        if (!this.isHtml(text) && this.isMarkdown(text)) {
            const mdInput = text.replace(/\\n/g, '\n');
            let markdown = new MarkdownIt({ breaks: true, linkify: true });
            let html = markdown.render(mdInput);
            html = html.replace(
                /<a\b([^>]*?)href="([^"]+)"([^>]*)>([\s\S]*?)<\/a>/gi,
                (match, pre, href, post, text) => {
                    const fullHref = href;
                    const hrefSinProtocolo = href.replace(/^https?:\/\//, '');
                    let visible = text;
                    if (!text || text === href || text === hrefSinProtocolo || /^https?:\/\//i.test(text) || text === decodeURIComponent(href) || text === decodeURIComponent(hrefSinProtocolo)) {
                        visible = decodeURIComponent(hrefSinProtocolo.split(/[?#]/)[0]);
                    }
                    return `<a${pre}href="${fullHref}"${post}>${visible}</a>`;
                }
            );
            return { html: html.replace(/a href=/g, "a target='_blank' href="), is_markdown: true };
        }
        let plain = this.urlify(text);
        plain = this.tostrongtext(plain);
        plain = plain.replace(/\\n/g, '<br>').replace(/\r?\n/g, '<br>');
        return { html: plain, is_markdown: false };
    }
    /*==================== ajecutar evento firebase ===================*/
    tostrongtext(text) {
        const parts = text.split(/(<a\b[^>]*>.*?<\/a>)/gi);
        return parts.map(part => {
            if (/^<a\b/i.test(part)) return part; // deja los links intactos
            // La negrita doble se resuelve primero: si no, /\*(.+?)\*/ captura desde
            // el primer asterisco hasta el tercero y deja asteriscos a la vista.
            const bolded = part
                .replace(/\*\*(.+?)\*\*/g, "<<BOLD>>$1<</BOLD>>")
                .replace(/\*(.+?)\*/g, "<strong>$1</strong>")
                .replace(/<<BOLD>>/g, "<strong>")
                .replace(/<<\/BOLD>>/g, "</strong>");
            const italicized = bolded.replace(
                /(^|[\s(])_(.+?)_(?=[\s).,;:!?]|$)/g,
                "$1<em>$2</em>"
            );

            return italicized;
        }).join('');
    }
}
export default new helperFunctions();
